/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.repeatable-booking', [
  'popup',
  'data.repeatable-booking'
]);
